 let nations=[
        {
            "id": "汉族",
            "name": "汉族"
          },
          {
            "id": "蒙古族",
            "name": "蒙古族"
          },
          {
            "id": "回族",
            "name": "回族"
          },
          {
            "id": "藏族",
            "name": "藏族"
          },
          {
            "id": "维吾尔族",
            "name": "维吾尔族"
          },
          {
            "id": "苗族",
            "name": "苗族"
          },
          {
            "id": "彝族",
            "name": "彝族"
          },
          {
            "id": "壮族",
            "name": "壮族"
          },
          {
            "id": "布依族",
            "name": "布依族"
          },
          {
            "id": "朝鲜族",
            "name": "朝鲜族"
          },
          {
            "id": "满族",
            "name": "满族"
          },
          {
            "id": "侗族",
            "name": "侗族"
          },
          {
            "id": "瑶族",
            "name": "瑶族"
          },
          {
            "id": "白族",
            "name": "白族"
          },
          {
            "id": "土家族",
            "name": "土家族"
          },
          {
            "id": "哈尼族",
            "name": "哈尼族"
          },
          {
            "id": "哈萨克族",
            "name": "哈萨克族"
          },
          {
            "id": "傣族",
            "name": "傣族"
          },
          {
            "id": "黎族",
            "name": "黎族"
          },
          {
            "id": "傈僳族",
            "name": "傈僳族"
          },
          {
            "id": "佤族",
            "name": "佤族"
          },
          {
            "id": "畲族",
            "name": "畲族"
          },
          {
            "id": "高山族",
            "name": "高山族"
          },
          {
            "id": "拉祜族",
            "name": "拉祜族"
          },
          {
            "id": "水族",
            "name": "水族"
          },
          {
            "id": "东乡族",
            "name": "东乡族"
          },
          {
            "id": "纳西族",
            "name": "纳西族"
          },
          {
            "id": "景颇族",
            "name": "景颇族"
          },
          {
            "id": "柯尔克孜族",
            "name": "柯尔克孜族"
          },
          {
            "id": "土族",
            "name": "土族"
          },
          {
            "id": "达斡尔族",
            "name": "达斡尔族"
          },
          {
            "id": "仫佬族32",
            "name": "仫佬族"
          },
          {
            "id": "羌族",
            "name": "羌族"
          },
          {
            "id": "布朗族",
            "name": "布朗族"
          },
          {
            "id": "撒拉族",
            "name": "撒拉族"
          },
          {
            "id": "毛难族",
            "name": "毛难族"
          },
          {
            "id": "仡佬族",
            "name": "仡佬族"
          },
          {
            "id": "锡伯族",
            "name": "锡伯族"
          },
          {
            "id": "阿昌族",
            "name": "阿昌族"
          },
          {
            "id": "普米族",
            "name": "普米族"
          },
          {
            "id": "塔吉克族",
            "name": "塔吉克族"
          },
          {
            "id": "怒族",
            "name": "怒族"
          },
          {
            "id": "乌孜别克族",
            "name": "乌孜别克族"
          },
          {
            "id": "俄罗斯族",
            "name": "俄罗斯族"
          },
          {
            "id": "鄂温克族",
            "name": "鄂温克族"
          },
          {
            "id": "崩龙族",
            "name": "崩龙族"
          },
          {
            "id": "保安族",
            "name": "保安族"
          },
          {
            "id": "裕固族",
            "name": "裕固族"
          },
          {
            "id": "京族",
            "name": "京族"
          },
          {
            "id": "塔塔尔族",
            "name": "塔塔尔族"
          },
          {
            "id": "独龙族",
            "name": "独龙族"
          },
          {
            "id": "鄂伦春族",
            "name": "鄂伦春族"
          },
          {
            "id": "赫哲族",
            "name": "赫哲族"
          },
          {
            "id": "门巴族",
            "name": "门巴族"
          },
          {
            "id": "珞巴族",
            "name": "珞巴族"
          },
          {
            "id": "基诺族",
            "name": "基诺族"
          }
       ]
    
  export default nations

